import { render, staticRenderFns } from "./shareFolder.vue?vue&type=template&id=7a2acdef&"
import script from "./shareFolder.vue?vue&type=script&lang=js&"
export * from "./shareFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports